import { useEffect } from "react";
import authService from '../services/authService';
import { useState } from "react";

function SessionTimeOut() {

    let ExpireTime = 0;
    const [events, setEvents] = useState(['click', 'load', 'scroll','keypress','scroll','mousemove','change','dblclick','wheel','touchmove']);


    //used to check for inactivity and logout
    const checkForInactivity = () => {
        //Get expire time from local storage
        // const expireTime = sessionStorage.getItem("expireTime"); // 15/06/23(User Req to remove MultiTab Login)
        const expireTime = localStorage.getItem("expireTime");

        const currentTime = Date.now()
        //if expire time is earlier than now, logout
        if (expireTime && expireTime < currentTime) {
            authService.logout();
        }
    }

    // used to Update expire time
    const updateExpireTime = () => {
        var logOutTime = 0;
        // Used to Get System Settings
        // const SystemSettings = JSON.parse(sessionStorage?.getItem("systemSettings")); // 15/06/23(User Req to remove MultiTab Login)
        const SystemSettings = JSON.parse(localStorage?.getItem("systemSettings"));
        if (SystemSettings) {
            // Used to Get logOutTime
            logOutTime = Number(SystemSettings[1].settingValue);
        }
        //set expire time from now
        ExpireTime = Date.now() + logOutTime;
        // set expire time in local storage
        // sessionStorage.setItem("expireTime", ExpireTime);  // 15/06/23(User Req to remove MultiTab Login)
        localStorage.setItem("expireTime", ExpireTime);
    }

    // used to set interval to check for inactivity
    useEffect(() => {
        var logOutTime = 0;
        // Used to Get System Settings
        // const SystemSettings = JSON.parse(sessionStorage?.getItem("systemSettings")); // 15/06/23(User Req to remove MultiTab Login)
        const SystemSettings = JSON.parse(localStorage?.getItem("systemSettings"));
        
        // const UserData = sessionStorage.getItem("user"); // 15/06/23(User Req to remove MultiTab Login)
        const UserData = localStorage.getItem("user");
        if(UserData && SystemSettings){
        if (SystemSettings) {
            // Used to Get logOutTime
            logOutTime = Number(SystemSettings[1].settingValue);
        }
        // check for inactivity every given time
        const interval = setInterval(() => {
            checkForInactivity();
        }, logOutTime);

        // clear interval on unmount
        return () => clearInterval(interval);
    }
    }, [])

    //used to update expire time on user activity
    useEffect(() => {
        // const UserData = sessionStorage.getItem("user");// 15/06/23(User Req to remove MultiTab Login)
        const UserData = localStorage.getItem("user");
        if(UserData && events){
        // set Initial expire time
        updateExpireTime();

        // set event listeners
        events.forEach((event) => {
            window.addEventListener(event, updateExpireTime);
          });

        // clean up
        return () => {
            events.forEach((event) => {
                window.addEventListener(event, updateExpireTime);
              });
        }
    }
    // }, [sessionStorage.getItem("user")]) // 15/06/23(User Req to remove MultiTab Login)
}, [localStorage.getItem("user")])
}

export default SessionTimeOut;